import { Component, Host, h, Event, type EventEmitter, Prop } from '@stencil/core';

@Component({
  tag: 'filters-reset',
  styleUrl: 'filters-reset.scss',
  shadow: false,
  scoped: true
})
export class FiltersReset {
  @Prop({ attribute: 'resetLabel' }) readonly resetLabel: string;
  @Event({bubbles: false}) searchReset: EventEmitter<void>;

  render() {
      return (
        <Host>
          <qds-button
            type="button"
            class="filters-reset"
            onClick={() => {
                this.searchReset.emit();
            }}
            text={this.resetLabel}
            iconName="arrow-up-down-circle"
            importance="subdued"
            size="small"
          />
        </Host>
      );
  }

}

